






















































































































import { FileApi } from "../../api/FileApi";
import Dropdown from "../UI/Dropdown.vue";

export default {
    name: "FileUploader",
    components: { Dropdown },
    props: {
        multipleFiles: Boolean,
        forwardedFiles: Array,
        availableFiles: Array,
    },
    data() {
        return {
            uploadedFiles: [],
            readOnlyFiles: [],
            photosFiles: [],
            FileApi: new FileApi(),
        };
    },
    methods: {
        handleFiles: function (event) {
            let self = this;
            let file = _.first(event.target.files);
            if (file) {
                self.uploadedFiles.push(file);
                file.status = 0;
                self.$emit("start-upload");
                self.FileApi.createDocument(file)
                    .then(function (res) {
                        file.id = res.data.data.id;
                        file.link = res.data.data.path;
                        file.status = 1;
                        self.$emit("end-upload");
                        self.updateFilesIds();
                        event.target.value = "";
                    })
                    .catch(function (error) {
                        file.status = 2;
                        file.errorMessage = error.response.statusText;
                        self.$emit("end-upload");
                        self.$forceUpdate();
                    });
            }
        },
        selectReadOnlyFile: function (file) {
            this.readOnlyFiles.push(file);
            this.updateFilesIds();
        },
        deleteFile: function (file) {
            let self = this;
            file.status = 0;
            self.FileApi.deleteDocument(file.id).then(function (res) {
                self.deselectFile(file);
            });
        },
        deselectFile: function (file) {
            _.remove(this.files, { id: file.id });
            _.remove(this.readOnlyFiles, { id: file.id });
            _.remove(this.photosFiles, { id: file.id });
            this.updateFilesIds();
        },
        updateFilesIds: function () {
            let selectedFiles = _.concat(
                this.readOnlyFiles,
                _.filter(this.uploadedFiles, { status: 1 })
            );
            let filesIds = _.map(selectedFiles, "id");
            this.$emit("files-uploaded", filesIds);
            let photoIds = _.map(this.photosFiles, "id");
            this.$emit("photos-updated", photoIds);
            this.$forceUpdate();
        },
        humanReadableSize: function (file) {
            return Math.round(file.size / 1000);
        },
    },
    watch: {
        forwardedFiles: {
            immediate: true,
            handler: function () {
                if (this.forwardedFiles) {
                    this.photosFiles = this.forwardedFiles;
                    this.updateFilesIds();
                }
            },
        },
    },
};
